import { useFormController, ValidationRules } from '@dreryk/react-common';
import {
   Accordion,
   componentsTranslationKeys,
   FormRouteLeavingPrompt,
   StyledMaxWidth,
   TextInput,
} from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

import {
   CreateAssociationVerificationCodeFormBean,
   CreateAssociationVerificationCodeFormController,
} from './CreateAssociationVerificationCodeForm.types';

type CreateAssociationVerificationCodeFormChildrenRendererProps = {
   handleSubmit: CreateAssociationVerificationCodeFormController['handleSubmit'];
};

type CreateAssociationVerificationCodeFormProps = {
   readonly children: (renderProps: CreateAssociationVerificationCodeFormChildrenRendererProps) => JSX.Element;
};

const ONE_TIME_CODE_LENGTH = 6;
const DIGITS_ONLY_REGEX = /^\d+$/gu;

const verificationCodeValidationRules: ValidationRules<CreateAssociationVerificationCodeFormBean> = {
   required: true,
   validate: (data) => {
      const verificationCode = data as string;
      if (verificationCode.length !== ONE_TIME_CODE_LENGTH || !verificationCode.match(DIGITS_ONLY_REGEX)) {
         return mfaSettingsTranslationKeys.verificationCodeValidation;
      }
      return undefined;
   },
};

export const CreateAssociationVerificationCodeForm = (
   props: CreateAssociationVerificationCodeFormProps
): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<CreateAssociationVerificationCodeFormBean>({
      verificationCode: null,
   });

   return (
      <>
         <StyledMaxWidth maxWidth={210}>
            <form noValidate onSubmit={(event) => event.preventDefault()}>
               <TextInput
                  testId={'verificationCode'}
                  controller={register('verificationCode', verificationCodeValidationRules)}
                  label={mfaSettingsTranslationKeys.verificationCode}
               />
            </form>
         </StyledMaxWidth>
         <Accordion.Section.ClosingConfirmation
            sectionId={'mfaSettings'}
            shouldConfirm={formState.isDirty}
            content={componentsTranslationKeys.formLeavingConfirmation}
            title={componentsTranslationKeys.leaveForm}
            confirmationButtonLabel={componentsTranslationKeys.leave}
         />
         <FormRouteLeavingPrompt formState={formState} />
         {props.children({ handleSubmit: handleSubmit })}
      </>
   );
};
